<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>권한 상품</strong> 기본 정보 (<span style="color:#ea0000">{{'구매된 권한상품 수 : '+Number(productAuthDatas.in_purchase_cnt).toLocaleString()}}</span>)
        </div>
        <div class="table-responsive-sm">
          <table class="table b-table table-striped">
              <thead class="" style="background-color:#f1f1f1">
                  <tr style="text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">상품코드</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">상품명</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">구분</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">상품적용기간</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">소비자가</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">등록일</th>
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">최종수정일</th>
                      <th class="" style="vertical-align:middle">노출여부</th>
                  </tr>
              </thead>
              <tbody class="">
                  <!---->
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="" style="border-right:1px solid #a4b7c1">{{productAuthDatas.p_code}}</td>
                      <td class="" style="border-right:1px solid #a4b7c1">{{productAuthDatas.p_name}}</td>
                      <td class="" style="border-right:1px solid #a4b7c1">{{productAuthDatas.p_typename}}</td>
                      <td class="" style="border-right:1px solid #a4b7c1">{{productAuthDatas.period_name}}</td>
                      <td class="" style="border-right:1px solid #a4b7c1">￦ {{productAuthDatas.price}}</td>
                      <td class="" style="border-right:1px solid #a4b7c1">{{productAuthDatas.reg_date}}</td>
                      <td class="" style="border-right:1px solid #a4b7c1">{{productAuthDatas.upt_date}}</td>
                      <td class="">{{productAuthDatas.view_name}}</td>
                  </tr>
              </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>서비스 권한 정보</strong>
        </div>
        <div style="margin-bottom:20px">
          <b-nav justified tabs>
            <b-nav-item v-bind:active="tapType == 'authtap'" v-on:click="tapType = 'authtap'">권한</b-nav-item>
            <b-nav-item v-bind:active="tapType == 'dctap'" v-on:click="tapType = 'dctap'">할인가</b-nav-item>
            <b-nav-item disabled></b-nav-item>
            <b-nav-item disabled></b-nav-item>
          </b-nav>
        </div>
        <div class="table-responsive-sm" v-show="tapType == 'authtap'">
          <table class="table b-table table-striped">
              <thead class="" style="background-color:#f1f1f1">
                  <tr style="text-align:center">
                      <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">메뉴 구분</th>
                      <th class="" style="vertical-align:middle">접근 권한</th>
                  </tr>
              </thead>
              <tbody class="">
                  <!---->
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-for="(pauth, idx) in productAuthDatas.svcAuthArr">
                    <td class="" style="border-right:1px solid #a4b7c1">{{pauth.svc_name}}</td>
                    <td class="">
                      {{pauth.svc_checkyn == 'Y' ? '열람 가능' : '열람 불가' }}
                    </td>
                  </tr>
                  <!-- <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="" style="border-right:1px solid #a4b7c1">비주얼브리프</td>
                      <td class="">
                        <b-form-select id="basicSelect"
                          :plain="true"
                          :options="[
                            {text:'사용 가능',value:'Y'},
                            {text:'사용 불가능',value:'N'},
                          ]"
                          :value="'Y'">
                        </b-form-select>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="" style="border-right:1px solid #a4b7c1">인뎁스리포트</td>
                      <td class="">
                        <b-form-select id="basicSelect"
                          :plain="true"
                          :options="[
                            {text:'사용 가능',value:'Y'},
                            {text:'사용 불가능',value:'N'},
                          ]"
                          :value="'Y'">
                        </b-form-select>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="" style="border-right:1px solid #a4b7c1">서베이리포트</td>
                      <td class="">
                        <b-form-select id="basicSelect"
                          :plain="true"
                          :options="[
                            {text:'사용 가능',value:'Y'},
                            {text:'사용 불가능',value:'N'},
                          ]"
                          :value="'Y'">
                        </b-form-select>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="" style="border-right:1px solid #a4b7c1">스페셜보고서</td>
                      <td class="">
                        <b-form-select id="basicSelect"
                          :plain="true"
                          :options="[
                            {text:'사용 가능',value:'Y'},
                            {text:'사용 불가능',value:'N'},
                          ]"
                          :value="'Y'">
                        </b-form-select>
                      </td>
                  </tr> -->
              </tbody>
          </table>
        </div>

        <div class="table-responsive-sm" v-show="tapType == 'dctap'">
          <table class="table b-table table-striped">
              <thead class="" style="background-color:#f1f1f1">
                  <tr style="text-align:center">
                      <th class="">할인가격 설정 정보</th>
                  </tr>
              </thead>
          </table>
          <div class="table-responsive-sm">
            <b-table
              striped
              hover
              :fields="dcFieldItems"
              :items="dcItems"
              :busy="dcItems == 0"
              :current-page="currentPage"
              :per-page="perPage">
              <div slot="table-busy" class="text-center my-2">
                <strong>데이터가 없습니다.</strong>
              </div>
              <template slot="p_price" slot-scope="data">
                <div style="width:200px">￦ {{Number(data.item.p_price).toLocaleString()}}</div>
              </template>
              <template slot="discount" slot-scope="data">
                <div style="width:200px">{{data.item.discount}}</div>
              </template>
              <template slot="dc_price" slot-scope="data">
                <div style="width:200px">￦ {{Number(data.item.dc_price).toLocaleString()}}</div>
              </template>
              <template slot="dc_result_price" slot-scope="data">
                <div style="width:200px">￦ {{Number(data.item.dc_result_price).toLocaleString()}}</div>
              </template>
              <template slot="dc_date" slot-scope="data">
                <div style="width:200px">{{data.item.dc_start_date}} ~ {{data.item.dc_end_date}}</div>
              </template>
              <template slot="complete_yn" slot-scope="data">
                <div style="width:200px; text-align:center" v-show="data.item.complete_yn == 'Y'">
                  <strong style="color:red; margin-top:3px">적용중</strong>
                </div>
                <div style="width:200px; text-align:center" v-show="data.item.complete_yn == 'N'">
                  <strong style="margin-top:3px">만료</strong>
                </div>
              </template>
            </b-table>
            <b-col sm="12" class="pt-sm-1">
              <b-row class="pb-sm-2">
                <b-col sm="1"></b-col>
                <b-col sm="12" class="my-1">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="dclistRows"
                    :per-page="perPage"
                    align="center"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
          </div>

        </div>
      </b-card>
      <b-row style="margin-bottom:1.5em">
        <b-col sm="3" lg="4">
          &nbsp;
        </b-col>
        <b-col sm="3" lg="4">
          &nbsp;
        </b-col>
        <b-col sm="3" lg="4">
          <div style="float:right; width:70%">
            <b-row>
              <b-col md="4">
                <b-button variant="danger" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #f42f2d; font-size:15px" v-on:click="drArDelete(auth_param_code)"><h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 삭제</h5></b-button>
              </b-col>
              <b-col md="4">
                <b-button variant="warning" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #c5940d; font-size:15px" v-bind:href="'#/product/userauthpermission/form?status=update'"><h5 style="margin-bottom:0px"><i class="fa fa-edit"></i> 수정</h5></b-button>
              </b-col>
              <b-col md="4">
                <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/product/userauthpermission'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import cSwitch from '../../components/Switch';
import swal from 'sweetalert2'

export default {
  components: {
    cSwitch,
  },
  data() {
    return {
      opttapCheck: true,
      pkgtapCheck: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      auth_param_code: '',
      tapType:'authtap',
      dcItems: [],
      drDeleteRows: [],
      productAuthDatas: {},
      productDataItems: {
        attachmentFileItems:[],
        previewFileItems:[],
        listThumbnailFile:[],
        categoryitems:[],
      },
      dcFieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'p_price': {
          'label': '소비자가',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'200px'
          }
        }
      }, {
        'discount': {
          'label': '할인율(%)',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'200px'
          }
        }
      }, {
        'dc_price': {
          'label': '할인금액',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'300px'
          }
        }
      }, {
        'dc_result_price': {
          'label': '할인적용금액',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'300px'
          }
        }
      }, {
        'dc_date': {
          'label': '할인기간',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'200px'
          }
        }
      }, {
        'complete_yn': {
          'label': '상태',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'120px'
          }
        }
      }],
      optList: [],
      pkgList: [],
      optiontap:'normaltap',
      tap_option_type:'POT_1',
    }
  },
  computed: {
    dclistRows() {
      return this.dcItems.length;
    }
  },
  watch: {},
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.auth_param_code = self.$session.get('auth_param_code');
    // ### 상품 정보 불러오기 ###
    // 상품정보를 DB테이블에서 조회
    // 최초작성 : 2016.06.27
    // 파라미터 : auth_param_code
    //  - auth_param_code
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.06.27  황경현   최초작성
    // *************************
    if(self.auth_param_code != undefined){
      self.$http.get('/api/select/drProductAuthData?access_token=' + token + '&p_param_code=' + self.auth_param_code)
      .then((result) => {
        self.productAuthDatas = result.data;
        self.productAuthDatas.price = Number(self.productAuthDatas.price).toLocaleString();
        self.getDcList(self.auth_param_code);
      })

      // ### 리포트 패키지 옵션 정보 불러오기 ###
      // 리포트정보 옵션을 DB테이블에서 조회
      // 최초작성 : 2016.06.27
      // 파라미터 : auth_param_code
      //  - auth_param_code
      // *************************
      // ## 코드 히스토리 ##
      //    날짜    작성자     수정내용
      // 2019.06.27  황경현   최초작성
      // *************************
      self.$http.get('/api/select/drProductOptList?access_token=' + token + '&p_param_code=' + self.auth_param_code)
      .then((result) => {
        self.optList = result.data.optList;
        self.pkgList = result.data.pkgList;
        if(self.pkgList.length > 0){
          self.pkgList.forEach(function (el, idx, arr){
            el.price = Number(el.price).toLocaleString();
          });
        }
      })
    }
  },
  methods: {
    reporttapOption (optiontype) {
      this.optiontap = optiontype;
    },
    optPkgCheck(event,check){
      if(!check){
        this.opttapCheck = !this.opttapCheck;
        this.pkgtapCheck = !this.pkgtapCheck;
      }else{
        event.target.checked = true;
      }
    },
    // 메소드명 : getDcList(auth_p_code)
    // ### 할인율 리스트 ###
    // 할인율 리스트 조회
    //
    // 최초작성 : 2016.07.05
    // 파라미터 :
    //  - auth_p_code(해당 권한상품 코드)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.05  황경현   최초작성
    // *************************
    getDcList (auth_p_code) {
      var token = sessionStorage.getItem("myToken");
      var self = this;

      self.$http.get('/api/select/drDcList?access_token=' + token + '&p_param_code=' + auth_p_code)
      .then((result) => {
        self.dcItems = result.data;
        console.log(self.dcItems);
      })
    },
    drArDelete(drCodeDel){
      var self = this;
      self.drDeleteRows = [];

      if(self.productAuthDatas.in_purchase_cnt > 0){
        swal.fire({
          type: 'warning',
          title: '권한상품 삭제!',
          html: "<b>구매된 권한상품은 삭제할수 없습니다.</br><span style='color:#ea0000'>구매건 수 : "+self.productAuthDatas.in_purchase_cnt+"건</span></b>",
          showConfirmButton: true
        })
        return false;
      }

      swal.fire({
        title: '권한상품 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "현재의 권한상품 및 할인가의 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          self.drDeleteRows.push(drCodeDel);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('dcDelArr', param);

          self.$http.post('/api/delete/drUserAuth?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '권한상품이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                  window.location = "#/product/userauthpermission";
              });
          })
        }else{
          // cansel
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/product/UserAuthPermissionInfo.vue